<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1 unnumbered" id="piano-fingers" style="padding-top:120px;">
<p><br/>This all started when I watched <em>The Secret</em>! Little did I know I would sell my house, buy a boat, start a new business – ‘Blue Diamond Elevation’, write this book, start a YouTube channel and paint my dreams.</p>
<p><br/>Co-creating with spirit is such a nurturing and uplifting experience. I love making the mundane magical, bringing a little sparkle into people’s lives.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?64c27532